import { F0TagDot } from '@factorialco/f0-react'
import { PerformanceReviewerStrategiesStrategyEnum } from 'generated/resources/graphql'

import { reviewTypePicker } from 'modules/performance_process/components/common/filters/reviewTypePicker'

import { colorPicker } from '../helpers/colorPicker'

export const ReviewTypeTag: React.FC<{
  type: PerformanceReviewerStrategiesStrategyEnum
}> = ({ type }) => <F0TagDot color={colorPicker(type)} text={reviewTypePicker(type)} />
